import { isRescueNet } from './isRescueNet';
import { isRescueNetNoPcr } from './isRescueNetNoPcr';
import { isTriTech } from './isTriTech';

export const widgets = {
  isRescueNet,
  isRescueNetNoPcr,
  isTriTech,
};
